export default __webpack_public_path__ + "static/media/Insuranceblack.6fb48839.svg";